import {
  ApiAppNamespaces,
  ApiBackofficeNamespaces,
  IQueuedRequest,
  OneAPIOptions
} from '../../common'
import { Queue } from '../../queue'
import { BackofficeCommentsApi } from './backoffice'
import { AppCommentsApi } from './app'

export class CommentsBackoffice implements ApiBackofficeNamespaces {
  backoffice: BackofficeCommentsApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.backoffice = new BackofficeCommentsApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.backoffice.invalidateAll()
  }
}

export class CommentsApp implements ApiAppNamespaces {
  app: AppCommentsApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppCommentsApi(name, sessionId, requestsQueue, options)
  }

  invalidateAll() {
    this.app.invalidateAll()
  }
}
